import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  deleteField,
} from "firebase/firestore";
import { db } from "../firebase/config";

const ACCESS_COLLECTION = "private";
const ACCESS_DOC_ID = "access";
const GRANTS_COLLECTION = "accessGrants";

function accessRef(matchId) {
  return doc(db, "matches", matchId, ACCESS_COLLECTION, ACCESS_DOC_ID);
}

function grantRef(matchId, uid) {
  return doc(db, "matches", matchId, GRANTS_COLLECTION, uid);
}

export async function fetchMatchAccess(matchId) {
  const snap = await getDoc(accessRef(matchId));
  return snap.exists() ? snap.data() : null;
}

export async function matchAccessExists(matchId) {
  const snap = await getDoc(accessRef(matchId));
  return snap.exists();
}

export async function createMatchAccess(matchId, { refCode, viewCode }) {
  await setDoc(accessRef(matchId), {
    refCode: refCode || "",
    viewCode: viewCode || "",
    updatedAt: serverTimestamp(),
  });
}

export async function createAccessGrant(
  matchId,
  uid,
  { role, accessCode, invitationId, source }
) {
  const payload = {
    role,
    grantedAt: serverTimestamp(),
  };
  if (accessCode !== undefined && accessCode !== null) {
    payload.accessCode = accessCode;
  }
  if (source) {
    payload.source = source;
  }
  if (invitationId) {
    payload.invitationId = invitationId;
  }
  await setDoc(grantRef(matchId, uid), payload);
}

export async function stripAccessCodeFromGrant(matchId, uid) {
  await updateDoc(grantRef(matchId, uid), {
    accessCode: deleteField(),
  });
}

export async function fetchAccessGrant(matchId, uid) {
  const snap = await getDoc(grantRef(matchId, uid));
  return snap.exists() ? snap.data() : null;
}

/**
 * Room organizer removes a guest's access grant (kick).
 * @param {string} matchId
 * @param {string} targetUid
 */
export async function revokeAccessGrant(matchId, targetUid) {
  if (!matchId || !targetUid) return;
  await deleteDoc(grantRef(matchId, targetUid));
}
